<p-select
  (onChange)="onSelect($event)"
  [class]="'select-width ' + styleClass"
  [disabled]="disabled"
  [invalid]="invalid"
  [ngModel]="value"
  [optionLabel]="optionLabel"
  [optionValue]="optionValue"
  [options]="selectedOption"
  [placeholder]="placeholder"
  [showClear]="showClear"
  appendTo="body"
>
  <ng-template #selectedItem let-selectedOption>
    <div class="flex items-center gap-2">
      <div>{{ stringTranslate + selectedOption[optionLabel] | translate }}</div>
    </div>
  </ng-template>
  <ng-template #item let-item>
    <div class="flex items-center gap-2">
      <div>{{ stringTranslate + item[optionLabel] | translate }}</div>
    </div>
  </ng-template>
</p-select>
